import { PaginatedResponse } from '@eagle/api-types';
import { ThingEventSnapshot } from '@eagle/core-data-types';
import { DriverBehaviorEventTypes, DuressEventTypes, FeatureTypes, InertiaEventTypes, TrackingEventTypes } from '@eagle/data-function-types';
import { PropsWithChildren, type JSX } from 'react';

export type EventTypes = DuressEventTypes | InertiaEventTypes.ROLLOVER | TrackingEventTypes | DriverBehaviorEventTypes | string;

interface ThingEventSnapshotTypes extends ThingEventSnapshot {
  eventTypeId: EventTypes;
  featureTypeId: FeatureTypes;
}

export interface SummarizedEventData extends EventLocationData {
  _isSummarized: true;
  _originalEvents: ThingEventSnapshot[];
  _eventCount: number;
  _summarizationMode: string;
}

export type AnyEventData = EventLocationData | SummarizedEventData;

export const isSummarizedEvent = (event: ThingEventSnapshot): event is SummarizedEventData => {
  return !!(event as SummarizedEventData)._isSummarized;
};

export interface ThingEventProperties {
  cluster: boolean;
  eventData: AnyEventData;
  iconColor: string;
  index: number;
  linkId?: string;
}

export interface EventBreadcrumbProps extends PropsWithChildren {
  center: L.LatLng;
  data: AnyEventData[];
  handleBreadcrumbClick?: () => void;
  icon?: JSX.Element;
  pathOptions?: L.PathOptions;
  radius?: number;
  setShowLineMarker?: (value: boolean) => void;
  toTop?: boolean;
}

export interface ThingEventItems {
  color: string;
  data: PaginatedResponse<AnyEventData>;
  entityDisplay: string;
  entityId: string;
  forceVisible?: boolean;
  focused: boolean;
  handleLoading?: (state: 'pending' | 'resolved' | 'rejected') => void;
  isOngoing?: boolean;
  isSelected: boolean;
  journeyId: string;
  mapMatchTolerance?: number;
  showLocationUpdates?: boolean;
  tripId?: string;
}

export interface EventLocationData extends ThingEventSnapshotTypes {
  data: {
    location: {
      latitude: number;
      longitude: number;
      source: string;
    };
    velocity?: {
      heading: number;
      speed: number;
    };
  };
}
